import { render, staticRenderFns } from "./Despachos.vue?vue&type=template&id=24c1ef24&scoped=true"
import script from "./Despachos.vue?vue&type=script&lang=js"
export * from "./Despachos.vue?vue&type=script&lang=js"
import style0 from "./Despachos.vue?vue&type=style&index=0&id=24c1ef24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c1ef24",
  null
  
)

export default component.exports